import React from "react";
import SettingsSectionIntro from "./SettingsSectionIntro";
import SettingsCard from "./SettingsCard";
import AccountSettingRow from "./AccountSettingRow";

export default function AccountSettingsPage({
  user,
  editingField,
  editingValue,
  saving,
  fieldError,
  editRowRef,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onEditingValueChange,
}) {
  const fields = [
    { label: "First Name", key: "first_name", value: user?.first_name },
    { label: "Last Name", key: "last_name", value: user?.last_name },
    { label: "Email", key: "email", value: user?.email, readOnly: true },
    { label: "Username", key: "username", value: user?.username },
    { label: "Company", key: "company_name", value: user?.company_name },
    { label: "Department", key: "department", value: user?.department, readOnly: true },
  ];

  return (
    <div className="flex flex-col gap-4 w-full">
      <SettingsSectionIntro
        title="Account Settings"
        description="Update your personal information and profile details."
      />

      <SettingsCard
        title="Profile"
        badge={
          <span className="inline-flex items-center rounded-full border border-blue-100 bg-white px-3 py-1 text-xs font-inter font-medium text-blue-700">
            {fields.length} fields
          </span>
        }
      >
        <div className="hidden md:grid grid-cols-[200px_1fr_auto] items-center py-2 bg-gray-50/50 px-5 gap-4 border-b border-gray-100">
          <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">Field</div>
          <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">Value</div>
          <div className="text-xs font-medium text-gray-400 uppercase tracking-wider w-16 text-center">Edit</div>
        </div>

        {fields.map(({ label, key, value, readOnly }) => (
          <AccountSettingRow
            key={key}
            label={label}
            fieldKey={key}
            value={value}
            readOnly={readOnly}
            isEditing={editingField === key}
            editingValue={editingValue}
            saving={saving}
            fieldError={fieldError}
            rowRef={editRowRef}
            onStartEdit={onStartEdit}
            onCancelEdit={onCancelEdit}
            onSaveEdit={onSaveEdit}
            onEditingValueChange={onEditingValueChange}
          />
        ))}
      </SettingsCard>
    </div>
  );
}
